// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1rlVN","footer":"ReportModalFilter_footer__pvbrI"};